import React from "react";

const Rate = () => {
    return (
        <div className="hero ">
            <div className="hero-content block md:flex lg:flex ">
                <div className="pl-10 text-white text-left mx-auto w-1/2">
                    <h1 className="text-4xl text-orange font-bold">Rate my Service!</h1>
                    <p className="py-6">Provident cupiditate voluptatem et in. Quaerat fugiat ut assumenda excepturi exercitationem quasi. In deleniti eaque aut repudiandae et a id nisi.</p>
                    <button className="btn btn-primary">Get Started</button>
                </div>
                <img src="https://i.ibb.co/6rXhQV2/cantaloupe-carving-1589340-1920-1.png"  className=" w-80% md:w-40% p-10 h-96 mx-auto rounded-lg shadow-2xl" alt =''/>
            </div>
        </div>
    );
}
export default Rate;